import React, { useEffect, useState } from "react";

import { CircularIndeterminate, FormButton } from "components";

import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    modalData,
    rowSelected,
    snackbarData,
    userCredentials,
} from "recoilState/GlobalState";

import { Form, Formik } from "formik";
import { FormikTextInput } from "components/UI/Inputs/FormikInputs";

import { ACTIONS } from "consts/Actions";

import { RequestServiceActions } from "services/services-mia/RequestServiceActions";

import styles from "styles/UI/ModalForm.module.scss";

export default function PublicModal({ updateList }) {
    const [isLoading, setIsLoading] = useState(false);
    const [inRequest, setInRequest] = useState(false);

    const row = useRecoilValue(rowSelected);
    const credentials = useRecoilValue(userCredentials);

    const setModalDetails = useSetRecoilState(modalData);
    const setSnackbarInfo = useSetRecoilState(snackbarData);

    const setXgridRowSelected = useSetRecoilState(rowSelected)

    const handleSubmit = async () => {
        setInRequest((inRequest) => !inRequest);
        setIsLoading((isLoading) => !isLoading);

        const body = {
            service: "SBMDocumentoPublicarDo",
            params: {
                sbmDocumentoId: row.row.id,
                sbmDocumentoVersion: row.row.version
            },
        }
        await RequestServiceActions(
            body,
            credentials,
            ACTIONS.UPDATE,
            setSnackbarInfo
        );
        await updateList();

        setModalDetails((modalState) => !modalState);

        setInRequest((inRequest) => !inRequest);
        setIsLoading((isLoading) => !isLoading);
    };
    useEffect(() => {
        return () => {
            setXgridRowSelected({ status: false, row: {} })
        }
    }, [])


    const internosFaltantes = row.row.firmantesInternos - (row.row.firmantesInternosRealizados ?? 0);
    const externosFaltantes = row.row.firmantesExternos - (row.row.firmantesExternosRealizados ?? 0);
    const hayFirmantesFaltantes = internosFaltantes > 0 || externosFaltantes > 0;

    if (hayFirmantesFaltantes) {
        const partes = [];
        if (internosFaltantes > 0) partes.push(`${internosFaltantes} firmante${internosFaltantes > 1 ? 's' : ''} interno${internosFaltantes > 1 ? 's' : ''}`);
        if (externosFaltantes > 0) partes.push(`${externosFaltantes} firmante${externosFaltantes > 1 ? 's' : ''} externo${externosFaltantes > 1 ? 's' : ''}`);
        return (
            <div className={styles.column}>
                <label className={styles.label}>
                    No es posible publicar el documento. Faltan agregar: {partes.join(' y ')}.
                </label>
            </div>
        );
    }

    return (
        <Formik
            initialValues={{
                nombreDocumento: row.row.nombre,
            }}
            onSubmit={(values, { setSubmitting }) => {
                try {
                    handleSubmit(values);
                } catch (e) {
                    setSnackbarInfo({
                        message: e.errmsg,
                        severity: "error",
                        open: true,
                    });
                } finally {
                    setSubmitting(false);
                }
            }}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles.column}>
                    <label className={styles.label}>
                        ¿Está seguro que desea publicar este documento?
                    </label>

                    <FormikTextInput
                        disabled={true}
                        fullWidth={false}
                        id="nombreDocumento"
                        name="nombreDocumento"
                        type="text"
                        value={row.row.nombre}
                    />

                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Publicar" }}
                    />

                    {isLoading && <CircularIndeterminate />}
                </div>
            </Form>
        </Formik>
    );
}
